import { EstimateBoqsTable } from "@pma/components/financials/estimate-boqs-list-table"
import { MainBoqsTable } from "@pma/components/financials/main-boqs-table"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@components/common/tabs"
import { cn } from "@pma/utils/helpers"
import useTranslator from "@pma/hooks/use-translator"
import { useAuth } from "@pma/stores/auth-store"
import { useLocation, useNavigate } from "react-router-dom"
import { DictType } from "@pma/types"
import { UserRoleProvider } from "@pma/contexts/UserRoleContext"

const BoQPage = () => {
  const { translate, locale } = useTranslator()

  const { authConfig, setTabManager } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const pathname = location.pathname
  const isHebrew = locale === "he"

  const allStateTabs = authConfig?.tabs ?? {}
  const boqActiveTab = allStateTabs ? allStateTabs["boq"] : undefined
  const activeTabs: DictType = boqActiveTab || {
    main: "estimates",
    sub: undefined,
  }
  return (
      <UserRoleProvider>
        <Tabs
          defaultValue={activeTabs?.main}
          className={cn("relative w-full max-w-[90vw] overflow-x-auto", isHebrew ? "rtl" : "ltr")}
        >
          <TabsList className='flex w-full items-center justify-center bg-transparent'>
            <TabsTrigger
              value='estimates'
              className={cn(
                "rounded-none border-primary bg-transparent data-[state=active]:border-b-2 data-[state=active]:bg-transparent data-[state=active]:shadow-none",
              )}
              onClick={() => {
                const params = new URLSearchParams(location.search)
                params.delete("main")
                params.delete("bill_tab")
                params.delete("revalidate")
                const search = params.toString()
                navigate(search ? `${pathname}?${search}` : pathname)

                setTabManager({
                  group: "boq",
                  main: "estimates",
                  sub: undefined,
                  subChild: undefined,
                })
              }}
            >
              {translate("Estimates")}
            </TabsTrigger>
            <TabsTrigger
              value='main'
              className={cn(
                "rounded-none border-primary bg-transparent data-[state=active]:border-b-2 data-[state=active]:bg-transparent data-[state=active]:shadow-none",
              )}
              onClick={() => {
                const params = new URLSearchParams(location.search)
                params.delete("estimate")
                const search = params.toString()
                navigate(search ? `${pathname}?${search}` : pathname)
                setTabManager({
                  group: "boq",
                  main: "main",
                  sub: "boq-tender",
                  subChild: "boq-items",
                })
              }}
            >
              {translate("Bills")}
            </TabsTrigger>
          </TabsList>
          <TabsContent value='estimates'>
            <EstimateBoqsTable />
          </TabsContent>
          <TabsContent value='main'>
            <MainBoqsTable />
          </TabsContent>
        </Tabs>
      </UserRoleProvider>
  )
}

export default BoQPage
